import React from "react";
import { Link } from "react-router-dom";

const ServiceProtocol = () => {
  return (
    <>
      <section className="section pricing__v2 cu_mtpd" id="pricing">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-8 mx-auto text-center">
              <span
                className="subtitle text-uppercase mb-3"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                Policies
              </span>
              <h2 className="mb-3 text-[32px]" data-aos="fade-up" data-aos-delay={100}>
                Service Protocol Terms
              </h2>
              <p data-aos="fade-up" data-aos-delay={200}>
                This Service Protocol governs the usage of all health plans provided by Veda Healthcure. By purchasing or using a Veda Health Plan, the User agrees to the following terms and conditions.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 mb-4 mb-md-0" data-aos="fade-up" data-aos-delay={300}>
              <section class="mb-4">
                <h2 class="text-2xl font-semibold mb-6">Section A: Enrolment & Identity Management</h2>
                <ul class="list-disc pl-6 space-y-4">
                  <li>
                    <strong>1.1. Family Composition:</strong>
                    Plans are defined for a "Family of 4" (unless specified otherwise).
                    Includes primary member, spouse, and two dependent children or parents.
                  </li>

                  <li>
                    <strong>1.2. Identity Lock-in:</strong>
                    <ul class="list-disc pl-6 mt-2 space-y-2">
                      <li>Full names, DOB, and Govt ID must be registered at enrolment.</li>
                      <li>Benefits are linked to Aadhaar/PAN provided at purchase.</li>
                    </ul>
                  </li>

                  <li>
                    <strong>1.3. No-Substitution Rule:</strong>
                    <ul class="list-disc pl-6 mt-2 space-y-2">
                      <li>Family members cannot be changed once plan is generated.</li>
                      <li>Names, ages, and phone numbers remain locked for 365 days.</li>
                    </ul>
                  </li>

                  <li>
                    <strong>1.4. Verification:</strong>
                    <ul class="list-disc pl-6 mt-2 space-y-2">
                      <li>Names must match Govt ID exactly.</li>
                      <li>Veda is not liable for denial due to mismatched details.</li>
                    </ul>
                  </li>
                </ul>
              </section>

              <section class="mb-4">
                <h2 class="text-2xl font-semibold mb-6">Section B: Teleconsultation & Credit Mechanics</h2>

                <ul class="list-disc pl-6 space-y-4">
                  <li><strong>2.1.</strong> 1 Credit equals 1 Consultation.</li>
                  <li><strong>2.2.</strong> Credits are deducted at booking time.</li>

                  <li>
                    <strong>2.3. 3-Call Attempt Rule:</strong>
                    <ul class="list-disc pl-6 mt-2 space-y-2">
                      <li>Doctor will attempt to call up to three times.</li>
                      <li>Calls may occur around selected or best available time.</li>
                    </ul>
                  </li>

                  <li><strong>2.4.</strong> Missing all attempts results in credit forfeiture.</li>
                  <li><strong>2.5.</strong> Cancellation or rescheduling is not permitted.</li>
                </ul>
              </section>

              <section class="mb-4">
                <h2 class="text-2xl font-semibold mb-6">Section C: Medicine Fulfilment & Pharmacy Services</h2>

                <ul class="list-disc pl-6 space-y-4">

                  <li>
                    <strong>3.1. Prescription Mandate:</strong>
                    Orders processed only against a valid prescription.
                  </li>

                  <li>
                    <strong>3.2. Product Scope:</strong>
                    <ul class="list-disc pl-6 mt-2 space-y-2">
                      <li>Only medicines listed on the website can be ordered.</li>
                      <li>FMCG items, supplements, and non-medicinal products excluded.</li>
                    </ul>
                  </li>

                  <li>
                    <strong>3.3. Ordering Limits:</strong>
                    <ul class="list-disc pl-6 mt-2 space-y-2">
                      <li>Max 5 units per medicine type per order.</li>
                      <li>Order value subject to plan limits.</li>
                      <li>Fulfilment depends on stock availability.</li>
                    </ul>
                  </li>

                  <li>
                    <strong>3.4. Shipping & Delivery:</strong>
                    <ul class="list-disc pl-6 mt-2 space-y-2">
                      <li>Metro delivery within 24 hours.</li>
                      <li>Non-metro delivery within 48-72 hours.</li>
                      <li>₹65 fee below ₹1200 orders.</li>
                      <li>Free delivery above ₹1200.</li>
                    </ul>
                  </li>

                  <li>
                    <strong>3.5. Returns:</strong>
                    <ul class="list-disc pl-6 mt-2 space-y-2">
                      <li>Medicines are non-returnable.</li>
                      <li>Wrong delivery must be reported within 24 hours.</li>
                    </ul>
                  </li>

                </ul>
              </section>

              <section class="mb-4">
                <h2 class="text-2xl font-semibold mb-6">Section D: Diagnostic & Radiology Services</h2>

                <ul class="list-disc pl-6 space-y-4">
                  <li><strong>4.1.</strong> Subsidy wallet is non-cash and non-withdrawable.</li>
                  <li><strong>4.2.</strong> Benefits apply only at partner labs.</li>
                  <li><strong>4.3.</strong> Discounts apply only to covered services.</li>
                  <li><strong>4.4.</strong> “Up to 20%” is the maximum cap.</li>
                  <li><strong>4.5.</strong> Veda not liable for third-party delivery delays.</li>
                </ul>
              </section>

              <section class="mb-4">
                <h2 class="text-2xl font-semibold mb-6">Section E: My Choice Doctor Reimbursement</h2>

                <ul class="list-disc pl-6 space-y-4">
                  <li><strong>5.1.</strong> Claims must be submitted within 7 days.</li>

                  <li>
                    <strong>5.2. Mandatory Documents:</strong>
                    <ul class="list-disc pl-6 mt-2 space-y-2">
                      <li>Signed prescription with doctor registration number.</li>
                      <li>GST invoice showing payment details.</li>
                    </ul>
                  </li>

                  <li><strong>Processing TAT:</strong> Refunds processed within 30-45 days.</li>
                </ul>
              </section>

              <section class="mb-4">
                <h2 class="text-2xl font-semibold mb-6">Section F: Limitation of Liability & Disclaimers</h2>

                <ul class="list-disc pl-6 space-y-4">
                  <li><strong>6.1.</strong> Veda is an aggregator, not a provider.</li>
                  <li><strong>6.2.</strong> Veda not responsible for medical outcomes.</li>
                  <li><strong>6.3.</strong> Users must contact service provider first.</li>
                  <li><strong>6.4.</strong> Not an emergency service.</li>
                </ul>
              </section>

              <section class="mb-4">
                <h2 class="text-2xl font-semibold mb-6">Section G: Plan Validity & Payments</h2>

                <ul class="list-disc pl-6 space-y-4">
                  <li><strong>7.1.</strong> Plans valid for 365 days.</li>
                  <li><strong>7.2.</strong> Payment gateway charges borne by user.</li>
                  <li><strong>7.3.</strong> Credit usage waives chargeback rights.</li>
                </ul>
              </section>

              {/* Note */}
              <div class="bg-gray-100 border-l-4 border-[#215c5c] p-6 rounded">
                <p class="font-medium">
                 Note: Veda Healthcure reserves the right to update this Service Protocol.
                  Users are encouraged to review periodically.
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default ServiceProtocol;
